<div #chartWrapper [ngClass]="parentComponent" class="tv-chart-container" [attr.id]="_containerId"></div>
